export default __webpack_public_path__ + "static/media/tabs_2.c89fca5f.png";